import i18next from "i18next";
const makeDefaults = (t) => Object.freeze({
    healthRecordExplanationTitle: t("What are health records?"),
    healthRecordExplanationText: t("Your health records are electronic"),
    recipientsAndThirdPartiesTitle: t("Who will have access to my health records?"),
    thirdPartyRedisclosureStatement: t("If your health records are shared with another person or organization"),
    healthRecordSourceAndScopeTitle: t("What’s included in my health records?"),
    healthRecordSourceAndScopeDisclosing: t("HealthEx accesses your health records from your healthcare providers and health plans that you have seen. HealthEx will only access the records for this request, and will protect them with strict privacy and security safeguards."),
    voluntaryHealthRecordUseTitle: t("Do I have to say yes?"),
    voluntaryHealthRecordUseText: t("Saying yes to sharing your health records is your choice. Your treatment"),
    consentExpirationAndRevocationTitle: (orgName) => t("How long will {{ orgName }} have access to my records?", { orgName }),
    consentExpirationAndRevocationExpiration: t("This agreement will end one year from the date you agree to share your records."),
    consentExpirationAndRevocationStatement: t("You can withdraw your permission at any time from the HealthEx patient portal."),
    requestingOrganization: (legalOrgName) => t("{{ legalOrgName }}", { legalOrgName }),
    consentDuration: t("1 year"),
    initialRecordAccessRequestTitle: t("Confirm access to your records"),
});
export function viewOnlyTextDefaults(studyTranslationLanguage) {
    return makeDefaults(i18next.getFixedT(studyTranslationLanguage, "common"));
}
